import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import {
  publicContextPropType,
  withPublicContext,
} from '../../../contexts/PublicContext/PublicContext';
import envConfig from '../../../envConfig';
import RaApiOrderMapperV1 from '../../../classes/mappers/orders/RaApiOrderMapperV1';
import { LoadingState } from '../../../utility/types/LoadingState';
import NotAuthenticatedOrderScreen
  from '../../orders/OrderDetailsPage/NotAuthenticatedOrderScreen/NotAuthenticatedOrderScreen';
import { getResourceIdFromURLParam } from '../../../utility/orderAndQuoteUtil';
import ShipmentTrackingModal
  from '../../orders/OrderDetails/ShipmentTrackingModal/ShipmentTrackingModal';
import CrmShipment from '../../../classes/CrmShipment';

class PublicOrderPage extends React.Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    const parsedId = getResourceIdFromURLParam(id);
    this.state = {
      loadingState: LoadingState.LOADING,
      orderDetails: { orderNumber: `ORD-${parsedId}` },
      showTrackingModal: false,
      shipmentList: [],
    };

    this.onGetTrackingDetails = this.onGetTrackingDetails.bind(this);
  }

  async componentDidMount() {
    const { publicContext, history, match } = this.props;
    const { id } = match.params;
    const hasPermission = await publicContext.hasAdnSession();
    if (!hasPermission) {
      await this.getData();
    } else {
      history.push(`/s/order/details/${id}`);
      window.location.reload();
    }
  }

  async getData() {
    const { match } = this.props;
    const { id } = match.params;
    const parsedId = getResourceIdFromURLParam(id);
    const validationId = id.split('-')[2];

    this.setState({ loadingState: LoadingState.LOADING });
    try {
      const orderResponse = await axios.get(
        `${envConfig.apiUrl}/api/v1/orders/public/${parsedId}-${validationId}`,
      );
      const shipmentsResponse = await axios.get(`${envConfig.apiUrl}/api/v1/shipments/shipment-list/${parsedId}-${validationId}`);

      const order = RaApiOrderMapperV1
        .mapJsonToOrderDetails(orderResponse.data.data.orderDetails);
      const newShipmentList = shipmentsResponse.data.data.shipmentList.map(
        (shipment) => new CrmShipment(
          shipment.id,
          shipment.shippingDate,
          shipment.carrier,
          shipment.shipMethod,
          shipment.trackingNumber,
          shipment.shipmentItemList,
          shipment.address,
          shipment.distributionOrigin,
        ),
      );

      this.setState({
        orderDetails: order,
        loadingState: LoadingState.COMPLETE,
        shipmentList: newShipmentList,
      });
    } catch (e) {
      this.setState({ loadingState: LoadingState.ERROR });
    }
  }

  onGetTrackingDetails(shipmentId) {
    const { shipmentList } = this.state;
    const trackedShipment = shipmentList.find((ship) => ship.id === shipmentId);
    this.setState({ trackedShipment, showTrackingModal: true });
  }

  // eslint-disable-next-line class-methods-use-this
  renderHeader() {
    return (
      <>
        <div className="row">
          <div className="col"><h3>Thank you for ordering Room Alert products.</h3></div>
        </div>
        <div className="row mb-4">
          <div className="col">
            Basic information about your order is listed below. For additional
            details and order tracking,
            {' '}
            <b>please log in to Room Alert Account</b>
            .
          </div>
          {' '}
        </div>
      </>
    );
  }

  render() {
    const {
      loadingState, orderDetails, showTrackingModal, trackedShipment,
    } = this.state;

    switch (loadingState) {
      case LoadingState.COMPLETE:
        return (
          <>
            {this.renderHeader()}
            <NotAuthenticatedOrderScreen
              order={orderDetails}
              loadError={false}
              shipmentList={orderDetails.shipmentList}
              onGetTrackingDetails={this.onGetTrackingDetails}
            />
            {showTrackingModal && (
              <ShipmentTrackingModal
                trackingNumber={trackedShipment.trackingNumber}
                shipTo={trackedShipment.shipToDisplay}
                shipFrom={trackedShipment.shipFromDisplay}
                onClose={() => this.setState({ showTrackingModal: false })}
              />
            )}
          </>
        );
      case LoadingState.ERROR:
        return (
          <>
            {this.renderHeader()}
            <NotAuthenticatedOrderScreen order={orderDetails} loadError />
          </>
        );
      case LoadingState.LOADING:
      default:
        return (
          <>
            {this.renderHeader()}
            <div className="row d-flex justify-content-center mt-5">
              <div><ProgressSpinner progressText="Loading..." /></div>
            </div>
          </>
        );
    }
  }
}

PublicOrderPage.propTypes = {
  publicContext: publicContextPropType.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
};

export { PublicOrderPage };

export default withPublicContext(withRouter(PublicOrderPage));
